import { NgModule } from '@angular/core';
import { ItemSelectOtherComponent } from './item-select-other/item-select-other';
import {IonicModule} from "ionic-angular";
import { StopwatchComponent } from './stopwatch/stopwatch';
import {TranslateModule} from "@ngx-translate/core";
import { Html5QrcodeComponent } from './html5-qrcode/html5-qrcode';
@NgModule({
	declarations: [
    ItemSelectOtherComponent,
    StopwatchComponent,
    Html5QrcodeComponent
  ],
    imports: [
        IonicModule,
        TranslateModule
    ],
	exports: [
    ItemSelectOtherComponent,
    StopwatchComponent,
    Html5QrcodeComponent
  ]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts